export default {
    title: 'Сбросить пароль',
    title_submitted: 'Готово! Проверьте вашу почту.',
    subtitle: 'Мы вышлем вам инструкции по сбросу пароля на электронную почту.',
    buttons: {
        back_to_login: 'Вернуться к входу',
    },
    notifications: {
        email_sent: 'Мы отправили письмо на ',
        with_instructions: ' с инструкциями по сбросу пароля.',
    },
}
